const api = {
  // contact: '/api/music/message'
  contact: 'https://access2.ro/music/message'
}

export default api
